import { Navigate, Route, Routes } from 'react-router-dom';

import { useAuth } from './auth/AuthProvider';
import { Nav } from './components/Nav';
import { ContractDetailPage } from './routes/ContractDetailPage';
import { ContractsPage } from './routes/ContractsPage';
import { CreateContractPage } from './routes/CreateContractPage';
import { DashboardPage } from './routes/DashboardPage';
import { LoginPage } from './routes/LoginPage';
import { SettingsPage } from './routes/SettingsPage';
import { TemplateEditorPage } from './routes/TemplateEditorPage';
import { TemplatesPage } from './routes/TemplatesPage';

export function App() {
  const { jwt } = useAuth();
  if (!jwt) {
    return <LoginPage />;
  }
  return (
    <div className="min-h-screen">
      <Nav />
      <main className="mx-auto max-w-6xl px-4 py-6">
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/templates/:id" element={<TemplateEditorPage />} />
          <Route path="/contracts" element={<ContractsPage />} />
          <Route path="/contracts/new" element={<CreateContractPage />} />
          <Route path="/contracts/:id" element={<ContractDetailPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
